<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :dialogVisible="dialogVisible"
    :title="$t('organizations.users_section.modals.edit_user.title')"
  >

  <template v-slot:body>
    <initial-avatar v-bind="$attrs" size="large" :avatarUrl="organizationUserData.photo_url" :userObject="organizationUserData" />
    <h4 class="user-full-name">{{userFullName}}</h4>
    <el-form
      :model="form"
      :rules="rules"
      hide-required-asterisk
      ref="editOrganizationUserForm"
    >
      <!-- <div class="user-organization-position">
        <elsa-input
          :label="$t('organizations.users_section.modals.edit_user.user_title')"
          name="title"
          prop="title"
          :placeholder="$t('organizations.users_section.modals.edit_user.user_title_placeholder')"
          :value="organizationUserData.title"
          v-model.lazy="form.title"
        />

        <elsa-input
          :label="$t('organizations.users_section.modals.edit_user.department')"
          name="department"
          prop="department"
          :placeholder="$t('organizations.users_section.modals.edit_user.department_placeholder')"
          :value="organizationUserData.department"
          v-model.lazy="form.department"
        />
      </div> -->

      <el-form-item
        class="select-role"
        prop="roles"
        :label="$t('organizations.users_section.select_role')"
        show-message
      >
        <el-checkbox-group class="elsa-checkbox-group" v-model="form.roles" @change="updateRoles">
          <el-checkbox
            v-for="({value, label}, idx) in getRoles"
            :key="idx"
            class="elsa-checkbox"
            :label="value"
          >{{$labelRole(currentOrganizationType, value)}}</el-checkbox>

        </el-checkbox-group>
      </el-form-item>
    </el-form>
  </template>
    <template v-slot:footer>
        <primary-button
          :disabled="form.roles.length===0"
          ref="submitEditOrganizationUserButton"
          @click.native="handleSubmitEditUser"
        >
          {{$t('common.save')}}
        </primary-button>
        <tertiary-button @click.native="$emit('closed')">
          {{$t('common.cancel')}}
        </tertiary-button>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import TertiaryButton from '@/components/common/buttons/TertiaryButton'
  import InitialAvatar from '@/components/common/InitialAvatar'
  // import ElsaInput from '@/components/common/Input'
  import { selectUserRoles } from '@/constants/userRoles'
  import { always, anyPass, pick, includes, compose, over, lensProp, toLower, map } from 'ramda'
  import {
    handleSubmitButtonState,
    isPropEmpty,
    handleFormValidation
  } from '../../../helpers/formValidationHelper'
  import {successMessage}  from '@/utils/messages'
  import { mapGetters } from 'vuex'

  export default {
    name: "EditOrganizationUser",
    props: {
      dialogVisible:{
        type: Boolean,
        default: false,
      },
      organizationUserData: {
        type: Object
      },
      organizationId: {

      }
    },
    components: {
      Modal,
      TertiaryButton,
      PrimaryButton,
      InitialAvatar,
      // ElsaInput,
    },
    data () {
      return {
        form: {
          roles: [],
        },
        rules: {
          department: [
            { required: true, message: this.$t('organizations.users_section.modals.edit_user.department_validation_msg'), trigger: ['blur'] }
          ],
          title: [
            { required: true, message: this.$t('organizations.users_section.modals.edit_user.title_validation_msg'), trigger: ['blur'] }
          ],
          roles: [
            { required: true, message: this.$t('organizations.users_section.modals.edit_user.role_validation_msg'), trigger: ['blur', 'change'] }
          ]
        }
      }
    },
    computed: {
      userFullName () {
        return `${this.organizationUserData.first_name} ${this.organizationUserData.last_name}`
      },
      selectUserRoles: always(selectUserRoles),
      getRoles () {
        return this.selectUserRoles;
      },
      ...mapGetters('organization', [
        'currentOrganizationType'
      ]),
    },
    methods: {
      hasRole (role, userRoles){
        return includes(role, userRoles);
      },
      handleSubmitEditUser () {
        const form = this.$refs.editOrganizationUserForm;
        return handleFormValidation(
          form,
          this.editOrganizationUser,
          this.showError
        )
      },
      showError () {
      },
      editOrganizationUser () {
        const organizationId = this.organizationId
        const userId = this.organizationUserData.id
        const roles = this.form.roles

        this.$store.dispatch('organization/postOrganizationUser', { organizationId, userId, roles})

        this.$emit('update:organizationUserData',{...this.organizationUserData, ...this.form, } )

        this.$store.dispatch('organization/getCurrentOrganizationAdmins')
        successMessage(this.$t('organizations.users_section.modals.edit_user.update_success'))(this)
        return this.$emit("closed")
      },
      updateRoles(roles) {
        this.form.roles = roles;
      }
    },
    watch: {
      form (newValue) {
        const submitButton = this.$refs.submitEditOrganizationUserButton.$el
        const valid = !anyPass([
          // isPropEmpty('title'),
          // isPropEmpty('department'),
          isPropEmpty('roles')
        ])(newValue)
        return handleSubmitButtonState(submitButton, valid)
      },
      dialogVisible: {
        handler () {
          this.form =
          compose(
            over(lensProp('roles'), map(toLower)),
            pick(['roles', 'title', 'department'])
          )(this.organizationUserData);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../scss/colors";

  ::v-deep .el-dialog.elsa-modal .el-dialog__body {
    padding-top: 32px;

    .el-form-item__label {
      text-transform: capitalize;
    }

    .user-organization-position {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-column-gap: 32px;
    }

    .user-avatar {
      border-radius: 100%;
      height: 112px;
      width: 112px;
      padding-bottom: 24px;
    }

    .user-full-name {
      font-weight: 500;
      font-size: 18px;
      color: $darker-blue;
      text-transform: capitalize;
      align-self: center;
      padding-bottom: 76px;
    }

    .select-role .el-form-item__label {
      margin-bottom: 16px;
    }

  }
</style>
